import { useLocation, useSearchParams } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import BreadCrumb from "../Common/BreadCrumb";
import NavHeader from "../Common/NavHeader";
import { useDeleteCrunchMapping,
    useDisableCategories,
    useEnableCategories,
    useGetCategoryDetails,
    useGetCrunchMapping,
    useClickbaconCoA,
    useAddCrunchMapping,
} from "./api";
import { Accordion, Spinner } from "react-bootstrap";
import { useState } from "react";
import EnableCategoriesModal from "./EnableCategoriesModal";
import DisableCategoriesModal from "./DisableCategoriesModal";
import AddCrunchMappingModal from "./AddCrunchMappingModal";
import { useGetAllCategories } from "../Classification/api";
import { useGetRestaurantCatageories } from "../Classification/api";
import { findTitleById } from "../Classification/utils";
import { Trash3 } from "react-bootstrap-icons";
import { queryClient } from "../../App";
import AddCustomCategoryModal from "./AddCustomCategoryModal";

const MAPPING_TYPES = ["Sales", "Discount", "Labor", "Other"];

const ManageCbCategory = () => {
    const [searchParams] = useSearchParams();
    const { pathname } = useLocation();
    const restaurant_id = pathname?.split("/")?.[2];
    const restaurant_name = searchParams.get("restaurant_name");
    const { mutate, isPending } = useEnableCategories();
    const { mutate: disableMutate, isPending: disabling } = useDisableCategories();
    const { mutate: deleteCrunchMapping } = useDeleteCrunchMapping();
    const [deleting, setDeleting] = useState(false);
    const [confirmingDelete, setConfirmingDelete] = useState(null);
    const [showAddMappingModal, setShowAddMappingModal] = useState(false);
    const [showAddCustomCategoryModal, setShowAddCustomCategoryModal] = useState(false);
    const { mutate: addCrunchMapping, isError: crunchMappingError, isPending: addingCrunchMapping } = useAddCrunchMapping();
    const { data, isLoading } = useGetCategoryDetails(restaurant_id);
    // Helper to render categories grouped by type
    const renderCategoryGroup = (categories) => {
        if (!categories) return null;

        return Object.keys(categories).map((groupKey) => {
            // Convert entries into array
            let entries = Object.entries(categories[groupKey]);

            // Sort so that items with "default" appear first
            entries.sort(([keyA, valueA], [keyB, valueB]) => {
                const aHasDefault = valueA?.toLowerCase().includes("default");
                const bHasDefault = valueB?.toLowerCase().includes("default");

                if (aHasDefault && !bHasDefault) return -1;
                if (!aHasDefault && bHasDefault) return 1;
                return valueA.localeCompare(valueB); // fallback alphabetical
            });

            return (
                <div key={groupKey} style={{ marginBottom: "15px" }}>
                    <h6
                        className="capitalize"
                        style={{
                            textAlign: "start",
                            marginBottom: "5px",
                            fontWeight: "bolder",
                            fontSize: "14px",
                            textTransform: "capitalize",
                        }}
                    >
                        {groupKey}
                    </h6>
                    <ul style={{ listStyle: "none", padding: 0 }}>
                        {entries.map(([key, value]) => (
                            <li
                                key={key}
                                style={{
                                    padding: "5px 0",
                                    borderBottom: "1px solid #eee",
                                    textAlign: "start",
                                    paddingLeft: "20px",
                                    fontSize: "12px",
                                }}
                            >
                                {value}
                            </li>
                        ))}
                    </ul>
                </div>
            );
        });
    };

    const [showEnableCategoryModal, setShowEnableCategoryModal] = useState(false);
    const [showDisableCategoryModal, setShowDisableCategoryModal] = useState(false);
    const [checkedEnabledItems, setCheckedEnabledItems] = useState([]);
    const [checkedDisabledItems, setCheckedDisabledItems] = useState([]);
    const transformData = (obj) => {
        return Object?.values(obj)?.map(item => {
            // Recursively transform children
            if (item?.children && item?.children?.length > 0) {
                item.children = transformData(item?.children?.reduce((acc, child) => {
                    acc[child?.value] = child;
                    return acc;
                }, {}));
            }
            return item;
        });
    };
    const custom_categories = {
        ...(data?.custom_category?.menu && { menu: transformData(data.custom_category.menu) }),
        ...(data?.custom_category?.labor && { labor: transformData(data.custom_category.labor) }),
        ...(data?.custom_category?.discount && { discount: transformData(data.custom_category.discount) }),
        ...(data?.custom_category?.other && { others: transformData(data.custom_category.other) }),
    };

    const default_categories = {
        ...(data?.default_category?.menu && { menu: transformData(data.default_category.menu) }),
        ...(data?.default_category?.labor && { labor: transformData(data.default_category.labor) }),
        ...(data?.default_category?.discount && { discount: transformData(data.default_category.discount) }),
        ...(data?.default_category?.other && { others: transformData(data.default_category.other) }),
    };
    const { data: crunchMapping, isLoading: loadingCrunchMapping } = useGetCrunchMapping(restaurant_id);
    const { data: categories, isLoading: loadingAiCategories } = useGetAllCategories({
        "restaurant_id": restaurant_id,
    });
    const { data: restaurant_categories, isLoading: loadingRestaurantCategories } = useGetRestaurantCatageories({
        "restaurant_id": restaurant_id,
    });

    const { data: CbCoA, isLoading: loadingCbCoA } = useClickbaconCoA(restaurant_id);

    const salesCategories = CbCoA?.data?.salesCategories || [];
    const discountCategories = CbCoA?.data?.discountCategories || [];
    const laborCategories = CbCoA?.data?.laborCategories || [];

    const extractSaleCategories = (categories) => {
        return categories
            .filter(cat => cat.type === "SALE")
            .map(cat => ({
                value: cat.id,
                label: cat.name,
                children: cat.children ? extractSaleCategories(cat.children) : []
            }));
    };
    const saleOnlyCategories = extractSaleCategories(salesCategories);

    const extractJobs = (categories) =>
        categories.flatMap((cat) =>
            (cat.jobs || []).map((job) => ({
                value: job.id,
                label: job.name,
            }))
        );
    const jobOnlyCategories = extractJobs(laborCategories);


    // response = the array you got from crunch-mapping API
    function groupCrunchMapping(response) {
        if (!response) return [];

        return response.map((item) => {
            const qboName = item?.quickbooksAccount?.name ?? "";

            return {
                crunchCategoryId: item?.crunchCategoryId,
                crunchName:
                    findTitleById(categories?.categories, item?.crunchCategoryId) ?? "-",

                name:
                    item?.category?.name ||
                    item?.laborJob?.name ||
                    item?.discount?.name ||
                    "-",

                qboName: qboName || "-", 

                type: item?.laborJob ? "Labor"
                    : item?.discount ? "Discount"
                    : item?.category && (item.category.type ?? "SALE") === "SALE" ? "Sales"
                    : "Other",
            };
        })
        .sort((a, b) =>
            (a.crunchName || "").localeCompare(b.crunchName || "")
        );
    }

    return (
        <>
            <ToastContainer />
            <NavHeader view="" />
            <div className="mx-2 mx-md-4" style={{ marginTop: "100px" }}>
                <BreadCrumb
                    showDatePicker={false}
                    showFilterDropdown={false}
                    text={`Home >  Manage CB Categories > ${restaurant_name}`}
                />
                {
                    isLoading ? <div className="d-flex justify-content-center align-items-center">
                        <Spinner animation="border" variant="primary" />
                    </div> :

                        <div style={{ display: "flex", gap: "10px" }} className="mx-md-2 flex-column flex-md-row cb-panels">
                            {/* Active Categories */}
                            <div className="rounded-2 border" style={{
                                width: "30%",
                                overflowY: "auto",
                                border: "1px solid grey",

                            }}>
                                <p
                                    style={{
                                        textAlign: "center",
                                        fontWeight: "bold",
                                        marginBottom: "10px",
                                        paddingBottom: "10px",
                                        paddingTop: "10px"
                                    }}
                                    className="border-bottom"
                                >
                                    Active Categories
                                </p>
                                <div
                                    style={{
                                        width: "100%",
                                        height: "430px",
                                        overflowY: data && Object?.keys(data?.active_categories)?.length > 0 ? "auto" : "hidden",
                                        // border: "1px solid grey",
                                        padding: "10px",
                                    }}
                                >

                                    {data && Object?.keys(data?.active_categories)?.length == 0 ?
                                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "450px" }}>
                                            <p style={{ fontSize: "14px", fontWeight: "normal" }}>No Active Categories Found.</p>
                                        </div>
                                        : renderCategoryGroup(data?.active_categories)}

                                </div>
                                {<div style={{ justifyContent: "center", display: "flex", flexWrap: "wrap", marginTop: "4px", marginBottom: "7px", gap: "10px" }}>
                                    <button onClick={() => {
                                        setShowEnableCategoryModal(true);
                                    }} className="btn btn-success px-4" style={{ fontSize: "12px", marginTop: "2px", justifyContent: 'center' }} >
                                        Enable Category
                                    </button>
                                    <button onClick={() => {
                                        setShowAddCustomCategoryModal(true);
                                    }} className="btn btn-success px-4" style={{ fontSize: "12px", marginTop: "2px", justifyContent: 'center' }} >
                                        Add Custom Category
                                    </button>
                                    
                                </div>}
                            </div>

                            {/* Disabled Categories */}
                            <div className="rounded-2 border" style={{
                                width: "25%",
                                overflowY: "auto",
                                border: "1px solid grey",

                            }}>
                                <p
                                    style={{
                                        textAlign: "center",
                                        fontWeight: "bold",
                                        marginBottom: "10px",
                                        paddingBottom: "10px",
                                        paddingTop: "10px"
                                    }}
                                    className="border-bottom"
                                >
                                    Disabled Categories
                                </p>
                                <div
                                    style={{
                                        width: "100%",
                                        height: "430px",
                                        overflowY: data && Object?.keys(data?.disabled_categories)?.length > 0 ? "auto" : "hidden",
                                        // border: "1px solid grey",
                                        padding: "10px",
                                    }}
                                >

                                    {data && Object?.keys(data?.disabled_categories)?.length == 0 ?
                                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "450px" }}>
                                            <p style={{ fontSize: "14px", fontWeight: "normal" }}>No Disabled Categories Found.</p>
                                        </div>
                                        : renderCategoryGroup(data?.disabled_categories)}

                                </div>
                                {<div style={{ justifyContent: "center", display: "flex", marginTop: "4px", marginBottom: "7px" }}>
                                    <button onClick={() => {
                                        setShowDisableCategoryModal(true);
                                    }} className="btn btn-success px-4" style={{ fontSize: "12px", marginTop: "2px", justifyContent: 'center' }} >
                                        Disable Category
                                    </button>
                                </div>}
                            </div>

                            {/* Crunch Mapping */}
                            <div
                                style={{
                                    width: "45%",

                                    // padding: "10px",
                                }}
                                className="border rounded-2"
                            >
                                <div

                                    style={{
                                        width: "100%",
                                        height: "500px",
                                        // padding: "10px",
                                    }}
                                >
                                    <p style={{
                                        textAlign: "center",
                                        fontWeight: "bold",
                                        marginBottom: "10px",
                                        // paddingBottom: "10px",
                                        padding: "10px"

                                    }}
                                        className="border-bottom">
                                        Crunch Mapping
                                    </p>
                                    {loadingCrunchMapping || loadingAiCategories ? <div className="d-flex justify-content-center align-items-center" style={{ height: "430px" }}>
                                        <Spinner animation="border" variant="primary" />
                                    </div> : (crunchMapping && crunchMapping?.length > 0 ? <div style={{ padding: "0px", height: "430px", overflowY: "auto" }}>
                                        <Accordion alwaysOpen defaultActiveKey={MAPPING_TYPES} flush>
                                        {MAPPING_TYPES.map((type) => {
                                            const rows = groupCrunchMapping(crunchMapping).filter((item) => item.type === type);
                                            if (!rows.length) return null;
                                            return (
                                        <Accordion.Item eventKey={type} key={type}>
                                        <Accordion.Header>{type} ({rows.length})</Accordion.Header>
                                        <Accordion.Body className="p-0">
                                        <table style={{ tableLayout: "fixed", width: "100%" }} className="table table-bordered">
                                            <thead className="bg-body-tertiary" style={{ position: "sticky", top: 0 }}>
                                                <tr style={{ textAlign: "start" }}>
                                                    <th style={{ fontSize: "12px", width: "30%" }}>Crunch Category </th>
                                                    <th style={{ fontSize: "12px", width: "30%" }}>CB CoA</th>
                                                    <th style={{ fontSize: "12px", width: "40%",zIndex:10 }}>QBO CoA</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {rows.map((item, index) => (
                                                    <tr key={index}>
                                                        <td style={{ fontSize: "12px" }} title={item?.crunchCategoryId}>{item?.crunchName || "-"}</td>
                                                        <td style={{ fontSize: "12px" }}>{item?.name}</td>
                                                        <td 
                                                            style={{ 
                                                                fontSize: "12px",
                                                                display: "flex",
                                                                justifyContent: "space-between",
                                                                alignItems: "center",
                                                                gap: "8px",
                                                                position: "relative",
                                                            }}
                                                        >
                                                            <span 
                                                                style={{
                                                                    overflow: "hidden",
                                                                    textOverflow: "ellipsis",
                                                                    whiteSpace: "nowrap",
                                                                    flexGrow: 1,
                                                                    minWidth: 0,
                                                                }}
                                                                title={item?.qboName}
                                                            >{item?.qboName || "-"}</span>

                                                            {(
                                                                <>
                                                                    <Trash3
                                                                        style={{ color: "red", cursor: "pointer", flexShrink: 0  }}
                                                                        onClick={() => setConfirmingDelete(item?.crunchCategoryId)}
                                                                    />

                                                                    {/* ✅ Confirmation Popup */}
                                                                    {confirmingDelete === item?.crunchCategoryId && (
                                                                        <div
                                                                            className="bg-body"
                                                                            style={{
                                                                                position: "absolute",
                                                                                top: "25px",
                                                                                right: "05px",
                                                                                border: "1px solid #ca4747ff",
                                                                                padding: "8px",
                                                                                borderRadius: "4px",
                                                                                boxShadow: "0px 2px 5px rgba(0,0,0,0.2)",
                                                                                zIndex: 10,
                                                                                fontSize: "12px",
                                                                                width: "140px",
                                                                            }}
                                                                        >
                                                                            <p style={{ margin: 0, marginBottom: "5px" }}>Delete this mapping?</p>
                                                                            <div style={{ display: "flex", justifyContent: "space-between" }}>
                                                                                <button
                                                                                    className="btn btn-sm btn-danger"
                                                                                    style={{
                                                                                        fontSize: "10px",
                                                                                        padding: "2px 6px"
                                                                                    }}
                                                                                    onClick={() => {
                                                                                        setDeleting(true);
                                                                                        deleteCrunchMapping(
                                                                                            { restaurant_id: restaurant_id, crunchCategoryId: item?.crunchCategoryId },
                                                                                            {
                                                                                                onSuccess: () => {
                                                                                                    setDeleting(false);
                                                                                                    setConfirmingDelete(null);
                                                                                                },
                                                                                                onError: () => {
                                                                                                    setDeleting(false);
                                                                                                    setConfirmingDelete(null);
                                                                                                }
                                                                                            }
                                                                                        );
                                                                                    }}
                                                                                >
                                                                                    Yes
                                                                                </button>
                                                                                <button
                                                                                    className="btn btn-sm btn-secondary"
                                                                                    style={{
                                                                                        fontSize: "10px",
                                                                                        padding: "2px 6px"
                                                                                    }}
                                                                                    onClick={() => setConfirmingDelete(null)}
                                                                                >
                                                                                    No
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                </>
                                                            )}
                                                        </td>

                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                        </Accordion.Body>
                                        </Accordion.Item>
                                            );
                                        })}
                                        </Accordion>
                                    </div> : <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "430px" }}>
                                        <p style={{ fontSize: "14px", fontWeight: "normal" }}>No Crunch Mapping Found.</p>
                                    </div>)}
                                    <div style={{ justifyContent: "center", display: "flex", marginTop: "4px", marginBottom: "7px" }}>
                                        <button
                                            onClick={() => {
                                                setShowAddMappingModal(true);
                                            }}
                                            className="btn btn-success px-4"
                                            style={{ fontSize: "12px", marginTop: "2px", justifyContent: "center" }}
                                        >
                                            Add Crunch Mapping
                                        </button>
                                    </div>
                                </div>
                            </div>

                        </div>
                }
            </div>
            <EnableCategoriesModal show={showEnableCategoryModal} setShow={setShowEnableCategoryModal} custom_categories={custom_categories} default_categories={default_categories} checkedItems={checkedEnabledItems} setCheckedItems={setCheckedEnabledItems} mutate={mutate} restaurant_id={restaurant_id} />
            <DisableCategoriesModal show={showDisableCategoryModal} setShow={setShowDisableCategoryModal} custom_categories={custom_categories} default_categories={default_categories} checkedItems={checkedDisabledItems} setCheckedItems={setCheckedDisabledItems} mutate={disableMutate} restaurant_id={restaurant_id} />
            <AddCrunchMappingModal
                show={showAddMappingModal}
                setShow={setShowAddMappingModal}
                crunchCategories={Object.fromEntries(["menu", "labor", "discount"].map((type) => [
                    type,
                    // custom categories come back with `title` instead of `category_name`
                    Object.entries(restaurant_categories?.data?.[type] || {}).map(([value, c]) => ({
                        value,
                        label: c?.category_name ?? c?.title,
                        custom: c?.custom,
                    })),
                ]))}
                cbCoaCategories={{
                    menu: saleOnlyCategories,
                    labor: jobOnlyCategories,
                    discount: [
                        ...Object?.values(discountCategories)
                    ]?.map(c => ({ value: c?.id, label: c?.name })),
                }}
                onAddMapping={({ crunchCategoryId, categoryId, accountType }) => {

                    // Call API here
                    return new Promise((resolve) => {

                        setTimeout(() => {
                            addCrunchMapping({ restaurant_id, crunchCategoryId, mappedId: categoryId, accountType }, {
                                onSuccess: () => {
                                    setShowAddMappingModal(false);
                                    queryClient.invalidateQueries({ queryKey: ["crunch-mapping"] })

                                    resolve();
                                },
                                onError: () => {
                                    resolve();
                                }
                            });

                        }, 1000);
                    });
                }}

            />
            <AddCustomCategoryModal  restaurant_id={restaurant_id} show={showAddCustomCategoryModal} setShow={setShowAddCustomCategoryModal} />
        </>
    );
};

export default ManageCbCategory;
